/** @format */

import {
	changeHeaderServiceStoreInfo,
	setHeaderServiceStoreInfo,
	setNearbyStores,
	setUserStoreInfoFromCookie,
	setUserStoreName,
	setUserZipCode
} from './header-location.actions';
import { createReducer, on } from '@ngrx/store';

import { HeaderLocation } from '@shared/data-access/interfaces';

export const initialHeaderLocationState: HeaderLocation = {
	storeName: '',
	zipCode: '',
	storeInfo: null,
	nearbyStores: null
};

export const headerLocationReducer = createReducer(
	initialHeaderLocationState,
	on(setUserStoreName, (state, { storeName }) => ({
		...state,
		storeName
	})),
	on(setUserStoreInfoFromCookie, (state, { zipcode, location, name }) => ({
		...state,
		storeInfo: {
			...state.storeInfo,
			name,
			zipcode,
			location,
		}
	})),
	on(setUserZipCode, (state, { zipCode }) => ({
		...state,
		zipCode
	})),
	on(setHeaderServiceStoreInfo, changeHeaderServiceStoreInfo, (state, { storeInfo }) => ({
		...state,
		storeInfo
	})),
	on(setNearbyStores, (state, { nearbyStores }) => ({
		...state,
		nearbyStores
	}))
);
